// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer__wrapper[data-v-96ff1598]{padding:100px 0 50px}@media (max-width:1023px){.footer__wrapper[data-v-96ff1598]{padding:64px 0}}@media (max-width:767px){.footer__wrapper[data-v-96ff1598]{padding:32px 0}}", ""]);
// Exports
module.exports = exports;
